	import $ from 'jquery';
    import _ from 'underscore';
    import Backbone from "backbone";
    import RSVP from "rsvp";

    const TRACK_FACEBOOK_EVENT_ON_APPFLYER = true;

    const FacebookEventTrackingHelper = Backbone.Model.extend({


        initialize : function() {

        },
        
        trackRegistration: function(isCreator, hasRSSFeed, accessCode){
            const params = {};
            params.isCreator = !!isCreator;
            params.hasRSSFeed = !!hasRSSFeed;
            params.accessCode = accessCode;
            params.appversionUnixCode =  window.trebbleAppVersion;
            params.platformContext =  this._getPlatformContext();
            params.adReference = window.trebble && window.trebble.adReference? window.trebble.adReference: null;
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("fb_mobile_complete_registration", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("CompleteRegistration", params)

                }
            }
        },

        _getPlatformContext : function(){
            if(window.waitForCordovaToLoad){
                return window.isIOSMobileDevice?"ios":"android";
            }else{
                return "browser";
            }
        },

        trackSubscriptionToAJourney : function(journeyIdWhoWasSubscribedTo){
            const params = {};
            params.journeyIdWhoWasSubscribedTo = journeyIdWhoWasSubscribedTo;
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("SubscribeToAJourney", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("SubscribeToAJourney", params, true);
                }
            }
        },

            trackSubscriptionToATrebble : function(trebbleIdWhoWasSubscribedTo){
            const params = {};
            params.trebbleIdWhoWasSubscribedTo = trebbleIdWhoWasSubscribedTo;
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("SubscribeToATrebble", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("SubscribeToATrebble", params, true);
                }
            }
        },

        trackUnsubscribeToATrebble : function(trebbleIdWhoWasUnsubscribed){
            const params = {};
            params.trebbleIdWhoWasUnsubscribed = trebbleIdWhoWasUnsubscribed;
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("UnsubscribeToATrebble", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("UnsubscribeToATrebble", params, true);
                }
            }
        },

                trackUnsubscribeToAJourney : function(journeyIdWhoWasUnsubscribed){
            const params = {};
            params.journeyIdWhoWasUnsubscribed = journeyIdWhoWasUnsubscribed;
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("UnsubscribeToAJourney", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("UnsubscribeToAJourney", params, true);
                }
            }
        },


        trackAddedShortcutToSiri : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("AddShortcutToSiri");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("AddShortcutToSiri",null, true);
                }
            }
        },

        trackModifiedShortcutToSiri : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("ModifyShortcutToSiri");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("ModifyShortcutToSiri", null, true);
                }
            }
        },

        trackDeletedShortcutToSiri : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("DeleteShortcutToSiri");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("DeleteShortcutToSiri", null, true);
                }
            }
        },

        trackCapsuleFeedPlayed : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("CapsuleFeedPlayed");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("CapsuleFeedPlayed", null, true);
                }
            }
        },

        trackCategoryShortcastRadioPlayed : function(categoryId){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("CategoryShortcastRadioPlayed",{"categoryId": categoryId});
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("CategoryShortcastRadioPlayed", {"categoryId": categoryId}, true);
                }
            }
        },

        trackSubscriptionPlayBackOrderSaved : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("SubscriptionPlayBackOrderSaved");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("SubscriptionPlayBackOrderSaved", null, true);
                }
            }
        },

        trackUserManuallyAgreedToTurnOnNotification: function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("UserManuallyAgreedToTurnOnNotification");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("UserManuallyAgreedToTurnOnNotification", null, true);
                }
            }
        },

        trackUserDidNotAgreeToTurnOnNotification: function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("UserDidNotAgreeToTurnOnNotification");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("UserDidNotAgreeToTurnOnNotification",null, true);
                }
            }
        },

        trackLeadWithIntentToSignup : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("LeadToSignup");
            }else{
                if ('fbq' in window) {
                    this._trackLead("signup");
                }
            }
        },

        // ===============================
        // SaaS Conversion Events for Ads
        // ===============================

        trackViewSubscriptionPlan: function(planType, price, currency) {
            const params = {};
            params.planType = planType;
            params.value = price;
            params.currency = currency || 'USD';
            params.content_type = 'subscription_plan';
            params.content_ids = [planType];
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("ViewContent", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("ViewContent", params);
                }
            }
        },

        trackInitiateSubscriptionCheckout: function(planType, price, currency) {
            const params = {};
            params.planType = planType;
            params.value = price;
            params.currency = currency || 'USD';
            params.content_type = 'subscription';
            params.content_ids = [planType];
            params.num_items = 1;
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("InitiateCheckout", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("InitiateCheckout", params);
                }
            }
        },

        trackAddPaymentInfoForSubscription: function(planType, price, currency) {
            const params = {};
            params.planType = planType;
            params.value = price;
            params.currency = currency || 'USD';
            params.content_type = 'subscription';
            params.content_ids = [planType];
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("AddPaymentInfo", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("AddPaymentInfo", params);
                }
            }
        },

        trackFirstProjectCreated: function(projectType) {
            const params = {};
            params.projectType = projectType || 'audio_editing';
            params.milestone = 'first_project_created';
            params.content_type = 'project_activation';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("FirstProjectCreated", params, true);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("FirstProjectCreated", params, true);
                }
            }
        },

        trackFirstContentExport: function(exportType, exportFormat) {
            const params = {};
            params.exportType = exportType || 'audio';
            params.exportFormat = exportFormat;
            params.milestone = 'first_export_completed';
            params.content_type = 'value_realization';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("FirstContentExport", params, true);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("FirstContentExport", params, true);
                }
            }
        },

        trackPowerUserMilestone: function(projectsCreated, exportsCompleted, timeSpentMinutes) {
            const params = {};
            params.projectsCreated = projectsCreated || 0;
            params.exportsCompleted = exportsCompleted || 0;
            params.timeSpentMinutes = timeSpentMinutes || 0;
            params.milestone = 'power_user_achieved';
            params.content_type = 'user_engagement';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("PowerUserMilestone", params, true);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("PowerUserMilestone", params, true);
                }
            }
        },

        trackAdvancedFeatureUsed: function(featureName) {
            const params = {};
            params.featureName = featureName;
            params.content_type = 'feature_adoption';
            params.milestone = 'advanced_feature_usage';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("AdvancedFeatureUsed", params, true);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("AdvancedFeatureUsed", params, true);
                }
            }
        },

        // ===============================
        // High-Value Engagement Events
        // ===============================

        trackUserSignup: function(signupMethod) {
            const params = {};
            params.signup_method = signupMethod || 'email';
            params.content_type = 'user_registration';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("CompleteRegistration", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("CompleteRegistration", params);
                }
            }
        },

        trackUserLogin: function(loginMethod) {
            const params = {};
            params.login_method = loginMethod || 'email';
            params.content_type = 'user_login';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("Lead", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("Lead", params);
                }
            }
        },

        trackContentShared: function(contentType, shareMethod) {
            const params = {};
            params.content_type = contentType || 'capsule';
            params.share_method = shareMethod || 'native';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("Share", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("Share", params);
                }
            }
        },

        trackEditorOpened: function(editorType) {
            const params = {};
            params.editor_type = editorType || 'audio_editor';
            params.content_type = 'editor_usage';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("Lead", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("Lead", params);
                }
            }
        },

        trackContentCreationStarted: function(contentType) {
            const params = {};
            params.content_type = contentType || 'capsule';
            params.action_type = 'creation_started';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("Lead", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("Lead", params);
                }
            }
        },

        // ===============================
        // AI Tool Usage Events
        // ===============================

        trackAIToolOpened: function(toolName) {
            const params = {};
            params.tool_name = toolName;
            params.content_type = 'ai_tool_usage';
            params.action_type = 'tool_opened';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("AI_Tool_Opened", params, true);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("AI_Tool_Opened", params, true);
                }
            }
        },

        trackAIOperationApplied: function(toolName, details) {
            const params = {};
            params.tool_name = toolName;
            params.content_type = 'ai_operation';
            params.action_type = 'operation_applied';
            params.platformContext = this._getPlatformContext();
            
            if (details) {
                if (details.changeCount) params.changes_applied = details.changeCount;
                if (details.duration) params.operation_duration = details.duration;
                if (details.success !== undefined) params.operation_success = details.success;
            }

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("AI_Operation_Applied", params, true);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("AI_Operation_Applied", params, true);
                }
            }
        },

        trackDeepCutWizardStarted: function(transcriptId) {
            const params = {};
            params.transcript_id = transcriptId;
            params.content_type = 'deepcut_wizard';
            params.action_type = 'wizard_started';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("Lead", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("Lead", params);
                }
            }
        },

        trackDeepCutWizardStep: function(stepNumber, stepName, transcriptId) {
            const params = {};
            params.step_number = stepNumber;
            params.step_name = stepName;
            params.transcript_id = transcriptId;
            params.content_type = 'deepcut_step';
            params.action_type = 'step_completed';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("DeepCut_Step_Completed", params, true);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("DeepCut_Step_Completed", params, true);
                }
            }
        },

        trackClipCreatorOpened: function(projectId) {
            const params = {};
            params.project_id = projectId;
            params.content_type = 'clip_creator';
            params.action_type = 'creator_opened';
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("Lead", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("Lead", params);
                }
            }
        },

        trackVideoRenderingStarted: function(details) {
            const params = {};
            params.content_type = 'video_rendering';
            params.action_type = 'rendering_started';
            params.platformContext = this._getPlatformContext();
            
            if (details) {
                if (details.projectId) params.project_id = details.projectId;
                if (details.templateType) params.template_type = details.templateType;
                if (details.duration) params.video_duration = details.duration;
                if (details.hasAudio !== undefined) params.has_audio = details.hasAudio;
            }

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("Video_Rendering_Started", params, true);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("Video_Rendering_Started", params, true);
                }
            }
        },

        trackPurchase : function(productInfo, isSandbox){
            if(productInfo){
                const value = productInfo.priceMicros/1000000;
                const currency = productInfo.currency;
                if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                    
                    this._logPurchaseFromCordovaFacebookPlugin( productInfo, value , currency, isSandbox);
                }else{
                    if ('fbq' in window) {
                        this._trackFacebookEvent("Purchase", {"value": value, "currency": currency});
                    }
                }
            }
        },

        trackSubscriptionPurchase: function(planType, price, currency, subscriptionId, isUpgrade, eventId) {
            const params = {};
            params.value = price;
            params.currency = currency || 'USD';
            params.planType = planType;
            params.subscriptionId = subscriptionId;
            params.content_type = 'subscription';
            params.content_ids = [planType];
            params.num_items = 1;
            params.isUpgrade = !!isUpgrade;
            params.platformContext = this._getPlatformContext();

            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logPurchaseFromCordovaFacebookPlugin(params, price, currency, false);
            }else{
                if ('fbq' in window) {
                    const trackOptions = eventId ? { eventID: eventId } : {};
                    this._trackFacebookEventWithOptions("Purchase", params, trackOptions);
                }
            }
        },

        trackCapsuleRecorded : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("CapsuleRecorded");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("CapsuleRecorded", null, true);
                }
            }
        },

        trackWasAwaredTrebblePlusFreeTrial  : function(numberOfDays){
            const params = {};
            params.numberOfDays = numberOfDays;
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("wasAwaredTrebblePlusFreeTrial",params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("wasAwaredTrebblePlusFreeTrial", params, true);
                }
            }
        },

        trackCapsuleCreated : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("CapsuleCreated");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("CapsuleCreated", null, true);
                }
            }
        },

        trackCapsuleUpdated : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("CapsuleUpdated");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("CapsuleUpdated", null, true);
                }
            }
        },

        trackUserRefusedToRateApp: function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("UserRefusedToRateApp");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("UserRefusedToRateApp", null, true);
                }
            }
        },

        trackUserSentSuggestionToImproveApp: function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("UserSentSuggestionToImproveApp");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("UserSentSuggestionToImproveApp", null, true);
                }
            }
        },

        trackUserPostponedAppRating: function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("UserPostponedAppRating");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("UserPostponedAppRating", null, true);
                }
            }
        },

        trackNumberOfTimesUserPostponedAppRating: function(numberOfTimes){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("userPostponedRatingTheApp"+numberOfTimes+"times");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("userPostponedRatingTheApp"+numberOfTimes+"times", null , true);
                }
            }
        },

        trackUserRatedApp : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("UserRatedApp");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("UserRatedApp", null , true);
                }
            }
        },


        trackNumberOfDaysCapsuleFeedWasPlayed: function(numberOfDays){
            const params = {};
            params.numberOfDays = numberOfDays;
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("numberOfDaysUserPlayedCapsuleFeed", params);
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("numberOfDaysUserPlayedCapsuleFeed", params, true);
                }
            }
        },


        trackDailyNotificationToListenToCapsuleFeedClicked : function(){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){
                this._logEventFromCordovaFacebookPlugin("DailyCapsuleFeedReadyNotificationClicked");
            }else{
                if ('fbq' in window) {
                    this._trackFacebookEvent("DailyCapsuleFeedReadyNotificationClicked",null, true);
                }
            }
        },

        _trackLead : function( intent, intentParams){
            if(window.waitForCordovaToLoad && window.facebookConnectPlugin){

            }else{
                if ('fbq' in window) {
                    const params = {};
                    params.intent = intent;
                    params.intentParams = intentParams;
                    this._trackFacebookEvent("Lead", params);

                }
            }
        },

        _logPurchaseFromCordovaFacebookPlugin : function( purchaseInfo, value , currency, isSandbox){
            try{
                const p =  new RSVP.Promise(function(resolve, reject){
                    if(window.facebookConnectPlugin && window.facebookConnectPlugin.logPurchase){
                        window.facebookConnectPlugin.logPurchase(value, currency, resolve, reject);
                    }else{
                        resolve();
                    }
                })
                if(TRACK_FACEBOOK_EVENT_ON_APPFLYER && window.plugins && window.plugins.appsFlyer && purchaseInfo){
                    window.plugins.appsFlyer.logEvent("purchaseTrebblePremiumSubscription", purchaseInfo ? purchaseInfo: {});
                }
                /*
                if(TRACK_FACEBOOK_EVENT_ON_APPFLYER && window.plugins && window.plugins.appsFlyer && purchaseInfo){
                    if(isSandbox){
                        window.plugins.appsFlyer.setUseReceiptValidationSandbox(true); // iOS -> for testing in sandbox environment
                    }
                    window.plugins.appsFlyer.validateAndLogInAppPurchase(purchaseInfo, function(){}, function(e){console.error(e)});
                }*/
                return p;
            }catch(error){
                console.error(error);
            }
        },

        _logEventFromCordovaFacebookPlugin : function( name,  params, valueToSum){
            try{
                const p =  new RSVP.Promise(function(resolve, reject){
                    if(window.facebookConnectPlugin && window.facebookConnectPlugin.logEvent){
                        window.facebookConnectPlugin.logEvent(name, params, valueToSum, resolve, reject);
                    }else{
                        resolve();
                    }
                })
                if(TRACK_FACEBOOK_EVENT_ON_APPFLYER && window.plugins && window.plugins.appsFlyer){
                    window.plugins.appsFlyer.logEvent(name, params ? params: {});
                }
                return p;
            }catch(error){
                console.error(error);
            }
        },

        _trackFacebookEvent : function(eventName, params, isCustom){
            try{

                window.fbq(isCustom?'trackCustom':'track', eventName,params);
                if(TRACK_FACEBOOK_EVENT_ON_APPFLYER && window.plugins && window.plugins.appsFlyer){
                    window.plugins.appsFlyer.logEvent(eventName, params ? params: {});
                }
            }catch(error){
                console.error(error);
            }
        },

        _trackFacebookEventWithOptions : function(eventName, params, options, isCustom){
            try{
                window.fbq(isCustom?'trackCustom':'track', eventName, params, options);
                if(TRACK_FACEBOOK_EVENT_ON_APPFLYER && window.plugins && window.plugins.appsFlyer){
                    window.plugins.appsFlyer.logEvent(eventName, params ? params: {});
                }
            }catch(error){
                console.error(error);
            }
        },
        

        

    });

    const FacebookEventTrackingHelperInstance = new FacebookEventTrackingHelper();

    export default {
		getInstance : function() {
			return FacebookEventTrackingHelperInstance;
		}
	};